import React, { useEffect } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import { getUserImagePath } from "helpers/imageService"

//redux
import { useSelector, useDispatch } from "react-redux"

import profileImg from "../../assets/images/profile-img.png"
import { useUserDetail } from "hooks"

//import action
import { addLMSProfile as onAddLMSProfile } from "../../store/actions"
import { isEmpty } from "lodash"

const WelcomeComp = () => {
  const dispatch = useDispatch()
  const { userprofile } = useUserDetail()

  //////////////////BASIC SETTING STATE/////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //////////////////////////////////////

  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col lg={12}>
          <div className="d-flex align-items-center">
            <img src={profileImg} alt="" className="avatar-sm rounded" />
            <div className="ms-3 flex-grow-1">
              <h5 className="mb-2 card-title">Hello, {userprofile.Name}</h5>
              <p className="text-muted mb-0">
                Welcome to Digital Health Days Impact Dashboard
              </p>
            </div>
            <div>
              <Link to="/profile" className="btn btn-primary">
                View Profile <i className="bx bx-plus align-middle"></i>
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default WelcomeComp
